import { Application } from "@hotwired/stimulus";
const application = Application.start();

import AutoSubmit from "@stimulus-components/auto-submit"
application.register("auto-submit", AutoSubmit)

import Carousel from "@stimulus-components/carousel";
application.register("carousel", Carousel);

import ColorPicker from "@stimulus-components/color-picker"
application.register("color-picker", ColorPicker)

// Dropdown and Notification cause the data-role-tooltip error in the browser console when clicking inside a rhino editor
import Dropdown from "@stimulus-components/dropdown";
application.register("dropdown", Dropdown);

import Notification from "@stimulus-components/notification";
application.register("notification", Notification);

import ReadMore from "@stimulus-components/read-more";
application.register("read-more", ReadMore);

import RevealController from "@stimulus-components/reveal";
application.register("reveal", RevealController);

import Sortable from "@stimulus-components/sortable";
application.register("sortable", Sortable);

import ScrollTo from "@stimulus-components/scroll-to";
application.register("scroll-to", ScrollTo);

import { Tabs } from "tailwindcss-stimulus-components"
application.register("tabs", Tabs)

import { UltimateTurboModalController } from "ultimate_turbo_modal"
application.register("modal", UltimateTurboModalController)

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };
